import {
  SELL_PANEL_ACTIVE,
  PAY_PANEL_LOADING,
  IS_COMPLETE_PANEL_ACTIVE,
  SALE_ORDER_DATA,
  CUS_OBJ,
  TAX_TABLE_DATA,
  DEFAULT_DEC_PLACES,
  SALE_PAYMENTS,
  PROD_TAB_DATA,
  CUS_ACC_DETAIL,
  ORDER_STATUSES,
  PAY_TYPES,
  IS_MAIN_LOADING,
  DATA_PRINT,
  PROMO_TABLE_DATA,
  IS_NOTE_VISIBLE,
  CURR_ORDER_STATUS,
  IS_CREDIT_ENABLED,
  IS_SELL_LOYALTY_ENABLED,
  LOYALTYAMOUNTVALUE,
  IS_DETAIL_LOADING,
  PREVENT_RUNNER_EXEC,
  IS_REFUNDABLE,
  PAY_PROCESS_START,
  IS_PARKED_VISIBLE,
  QUICK_KEYS_DETAILS,
  IS_FOLDER_OPEN,
  QUICK_KEY_COUNT,
  MAIN_QUICK_KEY_DETAILS,
  ACTIVE_FOLDER_DATA,
  ACTIVE_COLOR_CODE,
  IS_PROD_LOADING,
  DISCOUNT_PRICE_TOTAL,
  SALES_STATUS_NAME,
  DISCOUNT_ROW_VISIBLE,
  PROMO_CODE_POPOVER_VISIBLE,
  IS_TAX_POPOVER_VISIBLE,
  IS_PROMO_POPOVER_VISIBLE,
  IS_DISCOUNT_POPOVER_VISIBLE,
  IS_PAY_POPOVER_VISIBLE,
  IS_TAX_EXCLUSIVE,
  DEFAULT_SALES_TAX_ID,
  IS_BASIC_PERCENT,
  FORM_DIS_CURR,
  FORM_DIS_PER,
  FORM_SELL_NOTE,
  FORM_AMOUNT_TO_PAY,
  FORM_LAYOUT_NAME,
  DEFAULT_LOYALTY_AMOUNT,
  REFUND_NEG_HANDLE,
  IS_EXCHANGE_SALE,
  REFUND_PROD_KEYS,
  IS_ROW_DATA_UPDATED,
  PROMO_CODE_NOTIFY,
  COMPLETE_SALE,
  EARNED_LOYALTY,
  SHOW_ISSUE_CREDIT_MODAL,
  ACC_LAYBY_CREDITAMOUNT,
  SALE_REMAINING_AMOUNT,
  DELETED_PROD,
  PROMO_PROMPT,
  SHOW_PROMO_PROMPT,
  LOAD_IS_IN_PROGRESS,
  TOTAL_SAVING,
  ISALLPAID,
  SINGLE_SCREEN_FOR_CART,
  LOAD_SINGLE_PAY,
  SEND_PRINT,
  CART_MAIN_CLASS,
  ALL_QUICK_KEY_DETAILS,
  ENABLE_TAX_CODE
} from '../../constants/ActionTypes'
import {
  SALES_ORDER_STATUSES,
  INHOUSE_PAYMENT_TYPE
} from '../../constants/StoreSetting'

const INIT_STATE = {
  getIsSalePanelActive: true,
  getIsPaymentPanelLoading: true,
  getIsPaymentPanelActionCompleteActive: false,
  getSaleOrderJson: {},
  getCustomerObj: {},
  getTableDataSellTax: [],
  getDefaultDecimalPlaces: 2,
  getSalePayments: [],
  getTableDataSaleProduct: [],
  getCustomerAccountDetails: [],
  getSalesOrderStatuses: SALES_ORDER_STATUSES,
  getStorePaymentTypes: INHOUSE_PAYMENT_TYPE,
  isMainLoading: false,
  getDataToPrint: {},
  getTableDataSellPromotion: [],
  getIsSalePaymentProcessStart: false,
  getIsNotesRowVisible: false,
  getCurrentSalesOrderStatusID: '12&&_9efa-1ea9-4faf-88ed-a48e65b46643', //Default Status set to Progress
  getIsStoreCreditEnabled: false,
  getIsLoyaltyEnabled: false,
  isDetailLoading: true,
  getPreventSellRunnerExecution: true,
  getIsRefundSale: false,
  getParkedSaleModalVisible: false,
  getQuickKeysDetails: [],
  getIsFolderActive: false,
  getQuickkeyCount: { rows: 5, columns: 5 },
  getMainQuickKeysDetails: [],
  getAllQuickKeysDetails: [],
  getActiveFolderData: [],
  getActiveColorCode: '#FF6900',
  getIsProductLoading: false,
  getDiscountPriceTotal: 0,
  getCurrentSalesOrderStatusName: '',
  getIsDiscountRowVisible: false,
  getIsPromoCodePopoverVisible: false,
  getIsTaxPopoverVisible: false,
  getIsPromotionPopoverVisible: false,
  getIsDiscountPopoverVisible: false,
  getIsPaymentPopoverVisible: false,
  getIsTaxExclusive: false,
  defaultSalesTaxID: '',
  getBasicIsPercent: true,
  formDiscPer: 0,
  formDiscCurr: 0,
  formSellNote: '',
  amountToPay: 0,
  formLayoutName: '',
  getDefaultLoyaltyAmount: 0.1,
  getIsRefundNeg: true,
  getIsExchangeSale: false,
  getRefundKeys: [],
  isRowDataUpdated: false,
  isSaleCompleted: false,
  getPromoCodeNotify: 0, // 1 for applied // 2 for invalid // 3 req incomplete
  getEarnedLoyalty: 0,
  getShowIssueCreditModal: false,
  getAccLaybyCreditAmount: [], // at 0 index will be total value && at 1 index will be calculated!
  getAmountDiff: '',
  deletedProds: [],
  getPromoPrompt: {},
  showPromoPrompt: false,
  isInProgress: false,
  getTotalSaving: 0,
  getLoyaltyAmountValue: '0',
  is_all_paid: 0,
  singleScreenForCart: false,
  showScreenPay: false,
  isSendPrint: false,
  cartMainClass: '',
  enableTaxCode: false
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SELL_PANEL_ACTIVE: {
      return {
        ...state,
        getIsSalePanelActive: action.payload
      }
    }
    case PAY_PANEL_LOADING: {
      return {
        ...state,
        getIsPaymentPanelLoading: action.payload
      }
    }
    case IS_COMPLETE_PANEL_ACTIVE: {
      return {
        ...state,
        getIsPaymentPanelActionCompleteActive: action.payload
      }
    }
    case SALE_ORDER_DATA: {
      return {
        ...state,
        getSaleOrderJson: action.payload
      }
    }
    case CUS_OBJ: {
      return {
        ...state,
        getCustomerObj: action.payload
      }
    }
    case TAX_TABLE_DATA: {
      return {
        ...state,
        getTableDataSellTax: action.payload
      }
    }
    case DEFAULT_DEC_PLACES: {
      return {
        ...state,
        getDefaultDecimalPlaces: action.payload
      }
    }
    case SALE_PAYMENTS: {
      return {
        ...state,
        getSalePayments: action.payload
      }
    }
    case PROD_TAB_DATA: {
      return {
        ...state,
        getTableDataSaleProduct: action.payload
      }
    }
    case CUS_ACC_DETAIL: {
      return {
        ...state,
        getCustomerAccountDetails: action.payload
      }
    }
    case ORDER_STATUSES: {
      return {
        ...state,
        getSalesOrderStatuses: action.payload
      }
    }
    case PAY_TYPES: {
      return {
        ...state,
        getStorePaymentTypes: action.payload
      }
    }
    case IS_MAIN_LOADING: {
      return {
        ...state,
        isMainLoading: action.payload
      }
    }
    case DATA_PRINT: {
      return {
        ...state,
        getDataToPrint: action.payload
      }
    }
    case PROMO_TABLE_DATA: {
      return {
        ...state,
        getTableDataSellPromotion: action.payload
      }
    }
    case PAY_PROCESS_START: {
      return {
        ...state,
        getIsSalePaymentProcessStart: action.payload
      }
    }
    case IS_NOTE_VISIBLE: {
      return {
        ...state,
        getIsNotesRowVisible: action.payload
      }
    }
    case CURR_ORDER_STATUS: {
      return {
        ...state,
        getCurrentSalesOrderStatusID: action.payload
      }
    }
    case IS_CREDIT_ENABLED: {
      return {
        ...state,
        getIsStoreCreditEnabled: action.payload
      }
    }
    case IS_SELL_LOYALTY_ENABLED: {
      return {
        ...state,
        getIsLoyaltyEnabled: action.payload
      }
    }
    case LOYALTYAMOUNTVALUE: {
      return {
        ...state,
        getLoyaltyAmountValue: action.payload
      }
    }
    case IS_DETAIL_LOADING: {
      return {
        ...state,
        isDetailLoading: action.payload
      }
    }
    case PREVENT_RUNNER_EXEC: {
      return {
        ...state,
        getPreventSellRunnerExecution: action.payload
      }
    }
    case IS_REFUNDABLE: {
      return {
        ...state,
        getIsRefundSale: action.payload
      }
    }
    case IS_PARKED_VISIBLE: {
      return {
        ...state,
        getParkedSaleModalVisible: action.payload
      }
    }
    case QUICK_KEYS_DETAILS: {
      return {
        ...state,
        getQuickKeysDetails: action.payload
      }
    }
    case IS_FOLDER_OPEN: {
      return {
        ...state,
        getIsFolderActive: action.payload
      }
    }
    case QUICK_KEY_COUNT: {
      return {
        ...state,
        getQuickkeyCount: action.payload
      }
    }
    case MAIN_QUICK_KEY_DETAILS: {
      return {
        ...state,
        getMainQuickKeysDetails: action.payload
      }
    }
    case ALL_QUICK_KEY_DETAILS: {
      return {
        ...state,
        getAllQuickKeysDetails: action.payload
      }
    }
    case ACTIVE_FOLDER_DATA: {
      return {
        ...state,
        getActiveFolderData: action.payload
      }
    }
    case ACTIVE_COLOR_CODE: {
      return {
        ...state,
        getActiveColorCode: action.payload
      }
    }
    case IS_PROD_LOADING: {
      return {
        ...state,
        getIsProductLoading: action.payload
      }
    }
    case DISCOUNT_PRICE_TOTAL: {
      return {
        ...state,
        getDiscountPriceTotal: action.payload
      }
    }
    case SALES_STATUS_NAME: {
      return {
        ...state,
        getCurrentSalesOrderStatusName: action.payload
      }
    }
    case DISCOUNT_ROW_VISIBLE: {
      return {
        ...state,
        getIsDiscountRowVisible: action.payload
      }
    }
    case PROMO_CODE_POPOVER_VISIBLE: {
      return {
        ...state,
        getIsPromoCodePopoverVisible: action.payload
      }
    }
    case IS_TAX_POPOVER_VISIBLE: {
      return {
        ...state,
        getIsTaxPopoverVisible: action.payload
      }
    }
    case IS_PROMO_POPOVER_VISIBLE: {
      return {
        ...state,
        getIsPromotionPopoverVisible: action.payload
      }
    }
    case IS_DISCOUNT_POPOVER_VISIBLE: {
      return {
        ...state,
        getIsDiscountPopoverVisible: action.payload
      }
    }
    case IS_PAY_POPOVER_VISIBLE: {
      return {
        ...state,
        getIsPaymentPopoverVisible: action.payload
      }
    }
    case IS_TAX_EXCLUSIVE: {
      return {
        ...state,
        getIsTaxExclusive: action.payload
      }
    }
    case DEFAULT_SALES_TAX_ID: {
      return {
        ...state,
        defaultSalesTaxID: action.payload
      }
    }
    case IS_BASIC_PERCENT: {
      return {
        ...state,
        getBasicIsPercent: action.payload
      }
    }
    case FORM_DIS_CURR: {
      return {
        ...state,
        formDiscCurr: action.payload
      }
    }
    case FORM_DIS_PER: {
      return {
        ...state,
        formDiscPer: action.payload
      }
    }
    case FORM_SELL_NOTE: {
      return {
        ...state,
        formSellNote: action.payload
      }
    }
    case FORM_AMOUNT_TO_PAY: {
      return {
        ...state,
        amountToPay: action.payload
      }
    }
    case FORM_LAYOUT_NAME: {
      return {
        ...state,
        formLayoutName: action.payload
      }
    }
    case DEFAULT_LOYALTY_AMOUNT: {
      return {
        ...state,
        getDefaultLoyaltyAmount: action.payload
      }
    }
    case REFUND_NEG_HANDLE: {
      return {
        ...state,
        getIsRefundNeg: action.payload
      }
    }
    case IS_EXCHANGE_SALE: {
      return {
        ...state,
        getIsExchangeSale: action.payload
      }
    }
    case REFUND_PROD_KEYS: {
      return {
        ...state,
        getRefundKeys: action.payload
      }
    }
    case IS_ROW_DATA_UPDATED: {
      return {
        ...state,
        isRowDataUpdated: action.payload
      }
    }
    case PROMO_CODE_NOTIFY: {
      return {
        ...state,
        getPromoCodeNotify: action.payload
      }
    }
    case COMPLETE_SALE: {
      return {
        ...state,
        isSaleCompleted: action.payload
      }
    }
    case EARNED_LOYALTY: {
      return {
        ...state,
        getEarnedLoyalty: action.payload
      }
    }
    case SHOW_ISSUE_CREDIT_MODAL: {
      return {
        ...state,
        getShowIssueCreditModal: action.payload
      }
    }
    case ACC_LAYBY_CREDITAMOUNT: {
      return {
        ...state,
        getAccLaybyCreditAmount: action.payload
      }
    }
    case SALE_REMAINING_AMOUNT: {
      return {
        ...state,
        getAmountDiff: action.payload
      }
    }
    case DELETED_PROD: {
      return {
        ...state,
        deletedProds: action.payload
      }
    }
    case PROMO_PROMPT: {
      return {
        ...state,
        getPromoPrompt: action.payload
      }
    }
    case SHOW_PROMO_PROMPT: {
      return {
        ...state,
        showPromoPrompt: action.payload
      }
    }
    case LOAD_IS_IN_PROGRESS: {
      return {
        ...state,
        isInProgress: action.payload
      }
    }
    case TOTAL_SAVING: {
      return {
        ...state,
        getTotalSaving: action.payload
      }
    }
    case ISALLPAID: {
      return {
        ...state,
        is_all_paid: action.payload
      }
    }
    case SINGLE_SCREEN_FOR_CART: {
      return {
        ...state,
        singleScreenForCart: action.payload
      }
    }
    case LOAD_SINGLE_PAY: {
      return {
        ...state,
        showScreenPay: action.payload
      }
    }
    case SEND_PRINT: {
      return {
        ...state,
        isSendPrint: action.payload
      }
    }
    case CART_MAIN_CLASS: {
      return {
        ...state,
        cartMainClass: action.payload
      }
    }
    case ENABLE_TAX_CODE: {
      return {
        ...state,
        enableTaxCode: action.payload
      }
    }
    default:
      return state
  }
}
